import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from '../../../../components/molecules/Form';
import { Namespace } from '../../../../translation/namespace';
import { Editor } from '../../../../components/molecules/Form/components/Editor';
import LiveRegion from '../../../../components/atoms/LiveRegion/LiveRegion';
import FormCheckbox from '../../../../components/molecules/Form/components/FormCheckbox/FormCheckbox';
import FormInput from '../../../../components/molecules/Form/components/FormInput/FormInput';
import FormsRow from '../../../../components/molecules/Form/components/FormsRow/FormsRow';
import { FormSubmitButton } from '../../../../components/molecules/Form/components/FormSubmitButton/FormSubmitButton';

type RichtextTemplateProps = {
  statusMessages: any;
  editorID: string;
  saveButtonText: string;
  abortRefetch: () => void;
};

export function RichtextTemplate({ statusMessages, editorID, saveButtonText, abortRefetch }: RichtextTemplateProps) {
  const { t } = useTranslation(Namespace.Editor);
  const { inputs, onChange, getStatus } = useFormContext();
  const { content } = inputs;
  const idSuffix = 'richtexttemplate';

  return (
    <>
      {inputs.collapsible && (
        <FormsRow>
          <FormCheckbox
            id={`${idSuffix}-switch-${editorID}`}
            labelTitle={t('inputs.collapsible.title')}
            labelHelpText={t('inputs.collapsible.helpText')}
            name={inputs.collapsible.name}
            layout="switch"
            disabled={inputs.collapsible.disabled}
            checked={inputs.collapsible.checked}
            value={inputs.collapsible.value}
            onChange={inputs.collapsible.onChange as any}
          />
        </FormsRow>
      )}
      {((inputs.collapsible?.checked && !inputs.collapsible.disabled) || inputs.title?.required === true) && (
        <FormsRow>
          <FormInput
            id={`${idSuffix}-title-${editorID}`}
            name={inputs.title.name}
            value={inputs.title.value}
            labelTitle={t('inputs.title.title')}
            maxLength={inputs && inputs.title.constraints && inputs.title.constraints.maxLength}
            pattern={inputs.title.constraints?.pattern}
            onChange={(event: any) => onChange(event.target.name, event.target.value)}
            required={inputs.title.required || inputs.collapsible?.value}
          />
        </FormsRow>
      )}
      <Editor
        value={content.value}
        name={content.name}
        constraints={content.constraints}
        id={editorID}
        onChange={(event: any) => {
          onChange(event.target?.name, event.target?.value);
          abortRefetch();
        }}
      />
      <div className="editor__button-container">
        <FormSubmitButton buttonLabel={saveButtonText} enabled />
      </div>
      <LiveRegion invisible={false} htmlTag="div">
        {getStatus(statusMessages)}
      </LiveRegion>
    </>
  );
}
